export default __webpack_public_path__ + "fccaac754be61bd55bb5e81fde1fcf99.png";